let baseUrl='http://162.14.122.251';

let commonUrl = {
    baseUrl,
}
 
export default commonUrl